module.exports = __webpack_public_path__ + "static/lamp-c38cea8352bd6e1737d9bc9f8dfabc1b.jpg";